module.exports = __webpack_public_path__ + "img/logo.45219ba6.png";